import { PureComponent, type ReactNode } from "react";
import { Route } from "react-router-dom";

import { cn } from "@btnet/utilities-core";

import { BTLinkSpaRoutingProvider } from "helpers/globalContext/BTLinkSpaRoutingProvider";

import { EnablePinchZooming } from "commonComponents/utilities/EnablePinchZooming/EnablePinchZooming";

import "./PrintPageLayout.less";

interface IPrintPageLayoutProps {
    /**
     * @deprecated use the `element` prop instead
     */
    component?: React.ComponentType<any>;
    element?: ReactNode;
    path?: string;
    exact?: boolean;
    minWidth?: number;
    maxWidth?: number;
    /**
     * Setting this to true can help constrain the print content to the maxWidth specified.
     * This is useful on pages that render dynamic HTML content provided by the user, e.g. from CKEditor,
     * which may unfortunately contain inline styles and fixed widths e.g. on HTML tables.
     * Use sparingly.
     */
    enforceContentWidth?: boolean;
    /**
     * Padding applied around the print content, in px. Defaults to 16. Pages that lay out their
     * own physically-sized page boxes (e.g. the schedule gantt print) pass 0 so the wrapper's
     * padding doesn't offset the page geometry.
     */
    contentPadding?: number;
}

export class PrintPageLayout extends PureComponent<IPrintPageLayoutProps> {
    render() {
        const {
            component: Component,
            element,
            minWidth = 700,
            maxWidth,
            enforceContentWidth,
            contentPadding = 16,
            ...rest
        } = this.props;

        const printPageStyles = `
            body {
                background: white;
            }
            body form {
                background: white !important;
            }
        `;
        let renderedContent: ReactNode;
        if (element) {
            renderedContent = <Route {...rest}>{element}</Route>;
        } else if (Component) {
            renderedContent = (
                <Route {...rest} render={(matchProps) => <Component {...matchProps} />} />
            );
        } else {
            throw new Error("You must provide either a component or an element to PrintPageLayout");
        }

        return (
            <>
                <EnablePinchZooming width={minWidth} />
                <style>{printPageStyles}</style>
                <div
                    className={cn("PrintPageLayout", {
                        EnforceContentWidth: enforceContentWidth,
                    })}
                    style={{
                        minWidth: minWidth,
                        maxWidth: maxWidth ?? "none",
                        margin: "auto",
                        padding: contentPadding,
                    }}
                >
                    {/* Core BTLink throws without ambient routing (ado-289381). See
                        DetailPageLayout for why SpaInfoContext deliberately stays out of it. */}
                    <BTLinkSpaRoutingProvider>{renderedContent}</BTLinkSpaRoutingProvider>
                </div>
            </>
        );
    }
}
